import React from "react";
import bannerImg from "../../assets/images/skinefit/imgs/Artboard 18.jpg";
// import { GiThreeLeaves, GiMedicines } from "react-icons/gi";
// import { MdOutlineFace4 } from "react-icons/md";
// import { IoEarthOutline } from "react-icons/io5";
// import { SiTemporal } from "react-icons/si";
// import { CiHeart } from "react-icons/ci";
import { IoMdCheckmark } from "react-icons/io";

const Banner = () => {
  return (
    <div className=" bg-[#EDF2E6]">
      <div className="mx-10 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="col-span-1 flex justify-center gap-10 flex-col items-center">
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>We offer affordably luxurious skincare.</h1>
                {/* <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p> */}
              </div>
            </div>
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>
                  We save your time and energy by simplifying your skincare
                  routine.
                </h1>
                {/* <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p> */}
              </div>
            </div>
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>
                  We heavily researched and developed to create a safe and
                  secure skincare for your skin.
                </h1>
                {/* <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p> */}
              </div>
            </div>
          </div>
          <div className="hidden lg:block col-span-1 mx-auto">
            <img src={bannerImg} className="h-96 object-cover" alt="" />
          </div>
          <div className="col-span-1 mt-10 md:mt-0 flex justify-center gap-10 flex-col items-center">
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>
                  You will see improvements of your skin condition within two
                  weeks.
                </h1>
                {/* <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p> */}
              </div>
            </div>
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>
                  Neither harmful chemical nor lab torture is our principle.
                </h1>
                {/* <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p> */}
              </div>
            </div>
            <div className="flex justify-start gap-2 w-full">
              <IoMdCheckmark className="text-2xl text-[#4E5F3B]" />
              <div className="">
                <h1>100% Orgainc</h1>
                <p className="text-xs">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
